import { useContactsQuery } from '@dashboard/generated/wp/platform';
import { useCurrentPage } from '@dashboard/hooks/route/useCurrentPage';

export default function useCurrentContacts() {
  const page = useCurrentPage();
  return useContactsQuery({ fetchPolicy: 'network-only', variables: { page } });
}
